import { api, getHeaders } from '@/api/client';
import type { ApiResponse } from '@/api/schema/common';

import { globalSearchResponseSchema, type GlobalSearchRequest, type GlobalSearchResponse } from './schema';

const SEARCH_URL = '/pms/api/globalSearch/search';
const SEARCH_TIMEOUT_MS = 2000; // frontend/api-patterns: 2s minimum for internal calls

export const globalSearch = async (request: GlobalSearchRequest): Promise<GlobalSearchResponse> => {
  const response = await api.post<ApiResponse<unknown>>(SEARCH_URL, request, {
    ...getHeaders(),
    timeout: SEARCH_TIMEOUT_MS
  });

  return globalSearchResponseSchema.parse(response.data.Data);
};
